
export default function MapEquipmentDirective() {
    return {
        template: require('./map-equipment.component.html'),
        transclude: true,
        controller: 'MapEquipmentController',
        restrict: 'E'
    };
}
